import { AppState } from "../../../states";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { TechnicianContactsActions } from "../../states/Contacts/TechnicianContactsState";
import { TechniciansContactsList } from "./TechniciansContactsList";
import { User } from "../../../../src/communications/states/WorkspacesState";

export interface StateToProps {
  contacts: any[];
  searchString: string;
  incomingCounters: any;
  selectedWorkspace: User | null;
}

export interface DispatchToProps {
  setActiveContact: (contact: any, index: number) => void;
  typeSearch: (phrase: string) => void;
  loadContacts: (contacts: any[]) => void;
}

const mapStateToProps = (state: AppState): StateToProps => ({
  contacts: state["call-center"].cmnc_tech_contacts.contacts,
  searchString: state["call-center"].cmnc_tech_contacts.serachPhrase,
  incomingCounters: state["call-center"].cmnc_tech_contacts.incomingCounters,
  selectedWorkspace: state["call-center"].cmnc_users.selectedWorkspace,
});

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchToProps => ({
  setActiveContact: bindActionCreators(
    TechnicianContactsActions.setActiveContact,
    dispatch
  ),
  typeSearch: bindActionCreators(
    TechnicianContactsActions.typeSearch,
    dispatch
  ),
  loadContacts: bindActionCreators(
    TechnicianContactsActions.loadContacts,
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TechniciansContactsList);
